import { render } from "./oneTimePassword.vue?vue&type=template&id=6e8b3a92&scoped=true"
import script from "./oneTimePassword.vue?vue&type=script&lang=js"
export * from "./oneTimePassword.vue?vue&type=script&lang=js"

import "./oneTimePassword.vue?vue&type=style&index=0&id=6e8b3a92&lang=scss&scoped=true"

import exportComponent from "/builds/oleksandr.makhovskyi/admin-template/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e8b3a92"]])

export default __exports__